import { Layout, _decorator } from 'cc';

const { ccclass } = _decorator;

@ccclass('InvisibleLayout')
export default class InvisibleLayout extends Layout {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    protected _checkUsefulObj() {
        this._usefulLayoutObj.length = 0;
        const { children } = this.node;
        for (let i = 0; i < children.length; ++i) {
            const child = children[i];
            const uiTrans = child._uiProps.uiTransformComp;
            if (uiTrans) {
                this._usefulLayoutObj.push(uiTrans);
            }
        }
    }
}
